import type { CorrelationWidgetKind } from "./correlationWidgetTypes";

export type CorrelationWidgetLayoutDefaults = {
  w: number;
  h: number;
  minW: number;
  minH: number;
  title: string;
};

export const CORRELATION_WIDGET_DEFAULTS: Record<
  CorrelationWidgetKind,
  CorrelationWidgetLayoutDefaults
> = {
  "corr-controls": { w: 24, h: 4, minW: 12, minH: 3, title: "Correlation Controls" },
  "corr-heatmap": { w: 10, h: 8, minW: 6, minH: 5, title: "Correlation Heatmap" },
  "corr-pair-grid": { w: 24, h: 10, minW: 12, minH: 6, title: "Correlation Pair Grid" },
  "corr-rolling": { w: 10, h: 8, minW: 6, minH: 5, title: "Rolling Correlation" },
};
